import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs

// Components

// Constants
import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface LiveTagProps {
  liveType: number
  isLessThenTenMinutes: boolean
}

const LIVE_TYPE_TEXT = {
  [ROOM_LIVE_TYPE.CURRENT]: 'LiveRoom_Tag__Live',
  [ROOM_LIVE_TYPE.FUTURE]: 'LiveRoom_Tag_Future',
  [ROOM_LIVE_TYPE.PAST]: 'LiveRoom_Tag_Past',
  LESS_THEN_TEN: 'LiveRoom_Tag_LessThenTen',
}

const LiveTag = (props: LiveTagProps) => {
  const { liveType, isLessThenTenMinutes } = props

  const { t } = useTranslation()

  const isLive = liveType === ROOM_LIVE_TYPE.CURRENT

  return (
    <div className={cx('liveTag')} data-is-ending={isLessThenTenMinutes && isLive} data-type={liveType}>
      <div className={cx('liveTag-dot')} data-is-ending={isLessThenTenMinutes && isLive} data-type={liveType} />
      <p className={cx('liveTag-text')}>{isLessThenTenMinutes && isLive ? t(LIVE_TYPE_TEXT.LESS_THEN_TEN) : t(LIVE_TYPE_TEXT[liveType])}</p>
    </div>
  )
}

export default LiveTag
